import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge conditional class names (clsx) then dedupe conflicting Tailwind
 * utilities (tailwind-merge). The single class-composition helper used across
 * every @taki/ui component.
 *
 * @example
 * cn('px-2 py-1', isActive && 'bg-primary', 'px-4') // -> 'py-1 bg-primary px-4'
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
